import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LegalService } from '../../services/legal.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  year: number;
  privacyUrl$ = this.legalService.getPrivacyUrl();
  constructor(private legalService: LegalService) { }

  ngOnInit(): void {
    this.year = new Date().getFullYear();
  }

}
